import LTR from "@brand-icons/global/diamond/diamond-ltr.svg";

import { iconFactory } from "../iconFactory";

export const DiamondIcon = iconFactory("DiamondIcon", LTR);
